var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "github",
    clipPath: "url(#clip0_204_29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "github-path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 0C38.8075 0 50 11.4748 50 25.6323C50 36.9548 42.845 46.5599 32.9175 49.9524C31.65 50.2049 31.2 49.4044 31.2 48.7219C31.2 47.8769 31.23 45.117 31.23 41.687C31.23 39.297 30.43 37.7371 29.5325 36.9421C35.1 36.3071 40.95 34.1394 40.95 24.2944C40.95 21.4944 39.98 19.2096 38.375 17.4146C38.635 16.7671 39.4925 14.1599 38.13 10.6299C38.13 10.6299 36.035 9.94306 31.2625 13.2581C29.265 12.6906 27.125 12.405 25 12.395C22.875 12.405 20.7375 12.6906 18.7425 13.2581C13.965 9.94306 11.865 10.6299 11.865 10.6299C10.5075 14.1599 11.365 16.7671 11.6225 17.4146C10.025 19.2096 9.04751 21.4944 9.04751 24.2944C9.04751 34.1144 14.885 36.3154 20.4375 36.9629C19.7225 37.6029 19.075 38.7319 18.85 40.3894C17.425 41.0444 13.805 42.178 11.575 38.2605C11.575 38.2605 10.2525 35.7977 7.7425 35.6177C7.7425 35.6177 5.305 35.5853 7.5725 37.1753C7.5725 37.1753 9.21 37.9628 10.3475 40.9253C10.3475 40.9253 11.815 45.5002 18.77 43.9502C18.7825 46.0927 18.805 48.1119 18.805 48.7219C18.805 49.3994 18.345 50.1923 17.0975 49.9548C7.16249 46.5673 0 36.9573 0 25.6323C0 11.4748 11.195 0 25 0Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.a38be643d17e18932d340926b08c0ced.svg";
export { ForwardRef as ReactComponent };